import React from 'react';
import { SvgProps, Svg } from '../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="154"
      height="151"
      viewBox="0 0 154 151"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g opacity="0.75">
        <rect
          x="0.5"
          width="151"
          height="151"
          rx="23.5938"
          fill="white"
          fillOpacity="0.15"
        />
        <g filter="url(#filter0_i_3454_59873)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M67.1946 23.4129C49.5957 37.0605 42.0685 60.8492 50.2558 82.5018C58.4441 104.157 79.8322 117.015 102.061 115.6C97.9918 118.755 93.3842 121.369 88.3078 123.288C61.2767 133.509 31.1919 120.184 21.1115 93.5245C11.0311 66.8654 24.7724 36.9681 51.8035 26.7471C56.8771 24.8287 62.0583 23.7398 67.1946 23.4129Z"
            fill="url(#paint0_linear_3454_59873)"
          />
        </g>
        <g filter="url(#filter1_bdii_3454_59873)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M50.0469 109.23C37.8913 108.881 28.8125 99.57 28.8125 87.2978C28.8125 74.7885 38.9533 64.6478 51.4625 64.6478C53.3753 64.6478 55.2327 64.8849 57.007 65.3313C62.1244 55.9284 72.0924 49.5469 83.5509 49.5469C98.9953 49.5469 111.732 61.1402 113.533 76.099C114.222 76.0139 114.924 75.97 115.637 75.97C125.019 75.97 132.624 83.5756 132.624 92.9575C132.624 102.181 125.273 109.004 116.109 109.232V109.241H50.0469V109.23Z"
            fill="url(#paint1_linear_3454_59873)"
            shapeRendering="crispEdges"
          />
        </g>
        <g filter="url(#filter2_dd_3454_59873)">
          <path
            d="M89.0615 61.7105C89.4578 60.7237 90.8547 60.7237 91.251 61.7105L93.5414 67.4142C93.7102 67.8344 94.1046 68.1209 94.5563 68.1516L100.689 68.5674C101.75 68.6393 102.181 69.9679 101.365 70.6496L96.6485 74.5906C96.301 74.8809 96.1504 75.3445 96.2608 75.7837L97.7604 81.7444C98.0198 82.7756 96.8897 83.5967 95.9891 83.0313L90.7835 79.7632C90.4 79.5224 89.9125 79.5224 89.529 79.7632L84.3234 83.0313C83.4228 83.5967 82.2927 82.7756 82.5521 81.7444L84.0517 75.7837C84.1621 75.3445 84.0115 74.8809 83.664 74.5906L78.9472 70.6496C78.1312 69.9679 78.5629 68.6393 79.6238 68.5674L85.7562 68.1516C86.2079 68.1209 86.6023 67.8344 86.7711 67.4142L89.0615 61.7105Z"
            fill="url(#paint2_linear_3454_59873)"
            shapeRendering="crispEdges"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_i_3454_59873"
          x="17.8047"
          y="23.4131"
          width="84.2559"
          height="103.315"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="2.35938"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_innerShadow_3454_59873"
          />
          <feOffset dx="2.35938" dy="9.4375" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_3454_59873"
          />
        </filter>
        <filter
          id="filter1_bdii_3454_59873"
          x="7.57812"
          y="28.3125"
          width="146.281"
          height="102.163"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImage" stdDeviation="3.53906" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_3454_59873"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="10.6172" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.065 0 0 0 0 0.4 0 0 0 0 0.29584 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_backgroundBlur_3454_59873"
            result="effect2_dropShadow_3454_59873"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_3454_59873"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-2.35938" />
          <feGaussianBlur stdDeviation="3.53906" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.678431 0 0 0 0 0.988235 0 0 0 0 0.803922 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect3_innerShadow_3454_59873"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.35938" />
          <feGaussianBlur stdDeviation="1.17969" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="effect3_innerShadow_3454_59873"
            result="effect4_innerShadow_3454_59873"
          />
        </filter>
        <filter
          id="filter2_dd_3454_59873"
          x="69.084"
          y="51.5332"
          width="42.1445"
          height="41.1201"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.35938" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3454_59873"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4.71875" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.678431 0 0 0 0 0.988235 0 0 0 0 0.803922 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_3454_59873"
            result="effect2_dropShadow_3454_59873"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_3454_59873"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_3454_59873"
          x1="4.48179"
          y1="49.5446"
          x2="107.012"
          y2="67.8103"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADFCCD" stopOpacity="0.5" />
          <stop offset="1" stopColor="#65DCB7" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3454_59873"
          x1="27.1381"
          y1="55.8294"
          x2="74.7502"
          y2="135.772"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E6F9EE" stopOpacity="0.09" />
          <stop offset="1" stopColor="#88E3C8" stopOpacity="0.5" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3454_59873"
          x1="65.8884"
          y1="62.0179"
          x2="80.1841"
          y2="97.7572"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADFCCD" stopOpacity="0.5" />
          <stop offset="1" stopColor="#65DCB7" />
        </linearGradient>
      </defs>
    </Svg>
  );
};

export default Icon;
